<template>
  <v-container>
    <dialog-popup
        :dialog="dialogValue"
        @dialogItem="handleAddChapter"
        @back="handleBack"
        @clearApiError="handleClearError"
        :label="'Chapter'"
        ghostText="+ Add"
        :description="''"
        :type="type"
        :buttonLabel="'Add'"
        :breakDescription="false"
        :allowSpecialCharacters="true"
        :isShowCharCounter="true"
        :max_char="50"
        :minLength="0"
        :maxWidth="'596'"
        :hideFloatingLabel="true"
        :orgObjectType="'chapter'"
        :apiError="errorMessage"
        :duplicateNotAllowed="true"
    />
  </v-container>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import DialogPopup from '@components/Modal/DialogPopup.vue';

const props = defineProps({
  type: {
    type: String,
    required: false,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  // Support Vue 2 pattern for backward compatibility
  value: {
    type: Boolean,
    default: undefined,
  },
  errorMessage: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue', 'input', 'onSave', 'clearError']);

const instance = getCurrentInstance();
const $loader = instance?.proxy?.$loader || { isAppLoading: false };

// Support both Vue 2 (value) and Vue 3 (modelValue) patterns
const dialogValue = computed(() => {
  return props.value !== undefined ? props.value : props.modelValue;
});

const handleAddChapter = (role) => {
  emit('onSave', role);
};

const handleBack = () => {
  // Emit both events for compatibility
  emit('update:modelValue', false);
  emit('input', false);
};

const handleClearError = () => {
  emit('clearError');
};
</script>

<style scoped>
/* Center the dialog title */
:deep(.modal-popup .dialog-title) {
  text-align: center !important;
  width: 100% !important;
  left: 0 !important;
  right: 0 !important;
  display: block !important;
  position: relative !important;
  margin: 0 auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  top: -10px !important;
  margin-top: 12px !important;
}

/* Ensure the column containing the title is centered */
:deep(.row-mid .v-col) {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
}

/* Override any Vuetify default padding that might affect centering */
:deep(.row-mid .v-col .dialog-title) {
  margin-left: auto !important;
  margin-right: auto !important;
}

/* Move icon to top-left */
:deep(.modal-popup .modal-btn) {
  left: 22px !important;
  right: auto !important;
  top: 3px !important;
}
</style>

<style>
/* Global styles to ensure title is centered - dialogs are teleported to body */
.modal-popup .dialog-title {
  text-align: center !important;
  width: 100% !important;
  left: 0 !important;
  right: 0 !important;
  display: block !important;
  position: relative !important;
  margin: 0 auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  top: -10px !important;
  margin-top: 12px !important;
}

.modal-popup .row-mid .v-col {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
}

/* Move icon to top-left - global styles */
.modal-popup .modal-btn {
  left: 22px !important;
  right: auto !important;
  top: 3px !important;
}

/* Set dialog height to 362px */
.modal-popup {
  height: 362px !important;
}

/* Set padding-top to spacing-4xl (32px) for action button */
.modal-popup .bottom-btn-dialog {
  padding-top: 32px !important;
}
</style>
